import { yupResolver } from "@hookform/resolvers/yup";
import { StackScreenProps } from "@react-navigation/stack";
import {
  Form,
  Page,
  Button,
  Card,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import { FormProvider, useForm } from "react-hook-form";
import { Colors } from "react-native-ui-lib";
import { CustomerRootParamList } from "../../../../types";
import { CustomerDetailsForm } from "../../../point-of-sale/components/CustomerDetailsForm";
import {
  createCustomerInputSchema,
  CustomerFormValues,
  defaultCustomerInputValues,
  useMutationCreateCustomer,
} from "../../../point-of-sale/utils/customer";

export type CreateCustomerScreenProps = StackScreenProps<
  CustomerRootParamList,
  "CreateCustomerScreen"
>;

export function CreateCustomerScreen({
  navigation,
}: CreateCustomerScreenProps) {
  const { showMessage } = useFlashMessages();

  const methods = useForm<CustomerFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultCustomerInputValues,
    resolver: yupResolver(createCustomerInputSchema),
  });

  const {
    formState: { isValid },
  } = methods;

  const { createCustomer } = useMutationCreateCustomer();

  async function onValidSubmit(formValues: any) {
    try {
      await createCustomer(formValues);
      showMessage({ message: "Customer created", severity: "success" });
      navigation.goBack();
    } catch {
      showMessage({ message: "Failed to create customer", severity: "error" });
    }
  }

  const footerMarkup = (
    <Button
      backgroundColor={Colors.action}
      color="white"
      disabled={!isValid}
      label="Create Customer"
      onPress={methods.handleSubmit(onValidSubmit, console.log)}
    />
  );

  return (
    <Page
      title="New Customer"
      secondaryTitle="Create a new customer"
      footer={footerMarkup}
    >
      <FormProvider {...methods}>
        <Form>
          <Card title="Customer Details">
            <CustomerDetailsForm />
          </Card>
        </Form>
      </FormProvider>
    </Page>
  );
}
